// Generated types for Question
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface QuestionReadAPI extends ScopedNodeReadAPI {
  /** The question text to display */
  question_text: string;
  /** Input type: choice, multi_choice, boolean, numeric, range, or text */
  type?: "choice" | "multi_choice" | "boolean" | "numeric" | "range" | "text";
  /** Options for choice/multi_choice: list of {label, value} objects */
  options?: unknown | null;
  /** Whether choice/multi_choice allows a custom 'Other' text entry */
  allow_other?: boolean;
  /** Minimum value for numeric/range questions */
  min_value?: number | null;
  /** Maximum value for numeric/range questions */
  max_value?: number | null;
  /** Step increment for numeric/range sliders */
  step?: number | null;
  /** Unit label for numeric/range values (e.g. 'kg', 'mm', '°C') */
  unit?: string | null;
  /** Default/suggested answer value (shape matches answer value for this type) */
  default_value?: unknown | null;
  /** How to render numeric/range: slider, input boxes, or both (default: both) */
  input_mode?: "slider" | "input" | "both" | null;
  /** Identifier for this question in the response dict */
  key: string;
  /** Order of this question in the list */
  order_index?: number;
}

export interface QuestionWriteAPI extends ScopedNodeWriteAPI {
  /** The question text to display */
  question_text: string;
  /** Input type: choice, multi_choice, boolean, numeric, range, or text */
  type?: "choice" | "multi_choice" | "boolean" | "numeric" | "range" | "text";
  /** Options for choice/multi_choice: list of {label, value} objects */
  options?: unknown | null;
  /** Whether choice/multi_choice allows a custom 'Other' text entry */
  allow_other?: boolean;
  /** Minimum value for numeric/range questions */
  min_value?: number | null;
  /** Maximum value for numeric/range questions */
  max_value?: number | null;
  /** Step increment for numeric/range sliders */
  step?: number | null;
  /** Unit label for numeric/range values (e.g. 'kg', 'mm', '°C') */
  unit?: string | null;
  /** Default/suggested answer value (shape matches answer value for this type) */
  default_value?: unknown | null;
  /** How to render numeric/range: slider, input boxes, or both (default: both) */
  input_mode?: "slider" | "input" | "both" | null;
  /** Identifier for this question in the response dict */
  key: string;
  /** Order of this question in the list */
  order_index?: number;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const QuestionReadAPISchema: z.ZodType<QuestionReadAPI> = ScopedNodeReadAPISchemaObject.extend({
  question_text: z.string(),
  type: z.enum(["choice", "multi_choice", "boolean", "numeric", "range", "text"]).optional(),
  options: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
  allow_other: z.boolean().optional(),
  min_value: z.number().nullable().optional(),
  max_value: z.number().nullable().optional(),
  step: z.number().nullable().optional(),
  unit: z.string().nullable().optional(),
  default_value: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
  input_mode: z.enum(["slider", "input", "both"]).nullable().optional(),
  key: z.string(),
  order_index: z.number().optional(),
}).passthrough();

export const QuestionWriteAPISchema: z.ZodType<QuestionWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  question_text: z.string(),
  type: z.enum(["choice", "multi_choice", "boolean", "numeric", "range", "text"]).optional(),
  options: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
  allow_other: z.boolean().optional(),
  min_value: z.number().nullable().optional(),
  max_value: z.number().nullable().optional(),
  step: z.number().nullable().optional(),
  unit: z.string().nullable().optional(),
  default_value: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
  input_mode: z.enum(["slider", "input", "both"]).nullable().optional(),
  key: z.string(),
  order_index: z.number().optional(),
}).passthrough();
